import dayjs from 'dayjs';

const CABINET_INFORMER_TEMPLATES_MAX = 20;

const INFORMER_EMOJI_OPTIONS = [...new Set([
  // Лица и эмоции
  '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
  '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩',
  '😘', '😗', '😚', '😙', '🥲', '😋', '😛', '😜',
  '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐',
  '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬',
  '😮‍💨', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷',
  '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴',
  '😵', '😵‍💫', '🤯', '🤠', '🥳', '🥸', '😎', '🤓',
  '🧐', '😕', '😟', '🙁', '☹️', '😮', '😯', '😲',
  '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢',
  '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫',
  '🥱', '😤', '😡', '😠', '🤬', '😈', '👿', '💀',
  '☠️', '💩', '🤡', '👹', '👺', '👻', '👽', '👾',
  '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀',
  '😿', '😾',
  // Жесты и люди
  '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏',
  '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆',
  '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛',
  '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️',
  '💅', '🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂',
  '🦻', '👃', '🧠', '🫀', '🫁', '🦷', '🦴', '👀',
  '👁️', '👅', '👄', '👶', '🧒', '👦', '👧', '🧑',
  '👱', '👨', '🧔', '👩', '🧓', '👴', '👵', '🙍',
  '🙎', '🙅', '🙆', '💁', '🙋', '🧏', '🙇', '🤦',
  '🤷', '👮', '🕵️', '💂', '🥷', '👷', '🤴', '👸',
  '👳', '👲', '🧕', '🤵', '👰', '🤰', '🤱', '👼',
  '🎅', '🤶', '🦸', '🦹', '🧙', '🧚', '🧛', '🧜',
  '🧝', '🧞', '🧟', '💆', '💇', '🚶', '🧍', '🧎',
  '🏃', '💃', '🕺', '🕴️', '👯', '🧖', '🧗', '🤸',
  '🏌️', '🏇', '⛷️', '🏂', '🏋️', '🤼', '🤽', '🤾',
  '🤺', '⛹️', '🏊', '🚣', '🧘', '🛀', '🛌',
  // Сердца и символы
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍',
  '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖',
  '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉️', '☸️',
  '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈',
  '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐',
  '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️',
  '📴', '📳', '🈶', '🈚', '🈸', '🈺', '🈷️', '✴️',
  '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹',
  '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘', '❌',
  '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨️',
  '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭', '❗',
  '❕', '❓', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️',
  '⚠️', '🚸', '🔱', '⚜️', '🔰', '♻️', '✅', '☑️',
  '✔️', '❎', '➕', '➖', '➗', '✖️', '♾️', '💲',
  '💱', '™️', '©️', '®️', '〰️', '➰', '➿', '🔚',
  '🔙', '🔛', '🔝', '🔜', '✳️', '✴️', '❇️', '©️',
  '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '🟤', '⚫',
  '⚪', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '🟫',
  '⬛', '⬜', '◼️', '◻️', '◾', '◽', '▪️', '▫️',
  '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘',
  '🔳', '🔲',
  // Природа и погода
  '🌍', '🌎', '🌏', '🌐', '🗺️', '🗾', '🧭', '🏔️',
  '⛰️', '🌋', '🗻', '🏕️', '🏖️', '🏜️', '🏝️', '🏞️',
  '🏟️', '🏛️', '🏗️', '🧱', '🪨', '🪵', '🛖', '🏘️',
  '🏚️', '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦',
  '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰',
  '💒', '🗼', '🗽', '⛪', '🕌', '🛕', '🕍', '⛩️',
  '🕋', '⛲', '⛺', '🌁', '🌃', '🏙️', '🌄', '🌅',
  '🌆', '🌇', '🌉', '♨️', '🎠', '🎡', '🎢', '💈',
  '🎪', '🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈',
  '🚉', '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎',
  '🚐', '🚑', '🚒', '🚓', '🚔', '🚕', '🚖', '🚗',
  '🚘', '🚙', '🛻', '🚚', '🚛', '🚜', '🏎️', '🏍️',
  '🛵', '🦽', '🦼', '🛺', '🚲', '🛴', '🛹', '🛼',
  '🚏', '🛣️', '🛤️', '🛢️', '⛽', '🚨', '🚥', '🚦',
  '🛑', '🚧', '⚓', '⛵', '🛶', '🚤', '🛳️', '⛴️',
  '🛥️', '🚢', '✈️', '🛩️', '🛫', '🛬', '🪂', '💺',
  '🚁', '🚟', '🚠', '🚡', '🛰️', '🚀', '🛸', '🛎️',
  '🧳', '⌛', '⏳', '⌚', '⏰', '⏱️', '⏲️', '🕰️',
  '🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘',
  '🌙', '🌚', '🌛', '🌜', '🌡️', '☀️', '🌝', '🌞',
  '⭐', '🌟', '🌠', '☁️', '⛅', '⛈️', '🌤️', '🌥️',
  '🌦️', '🌧️', '🌨️', '🌩️', '🌪️', '🌫️', '🌬️', '🌀',
  '🌈', '🌂', '☂️', '☔', '⛱️', '⚡', '❄️', '☃️',
  '⛄', '☄️', '🔥', '💧', '🌊', '🎄', '🎋', '🎍',
  '🎎', '🎏', '🎐', '🎑', '🧧', '🎀', '🎁', '🎗️',
  '🎟️', '🎫', '🎖️', '🏆', '🏅', '🥇', '🥈', '🥉',
  // Еда и напитки
  '🍇', '🍈', '🍉', '🍊', '🍋', '🍌', '🍍', '🥭',
  '🍎', '🍏', '🍐', '🍑', '🍒', '🍓', '🫐', '🥝',
  '🍅', '🫒', '🥥', '🥑', '🍆', '🥔', '🥕', '🌽',
  '🌶️', '🫑', '🥒', '🥬', '🥦', '🧄', '🧅', '🍄',
  '🥜', '🌰', '🍞', '🥐', '🥖', '🫓', '🥨', '🥯',
  '🥞', '🧇', '🧀', '🍖', '🍗', '🥩', '🥓', '🍔',
  '🍟', '🍕', '🌭', '🥪', '🌮', '🌯', '🫔', '🥙',
  '🧆', '🥚', '🍳', '🥘', '🍲', '🫕', '🥣', '🥗',
  '🍿', '🧈', '🧂', '🥫', '🍱', '🍘', '🍙', '🍚',
  '🍛', '🍜', '🍝', '🍠', '🍢', '🍣', '🍤', '🍥',
  '🥮', '🍡', '🥟', '🥠', '🥡', '🦀', '🦞', '🦐',
  '🦑', '🦪', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂',
  '🍰', '🧁', '🥧', '🍫', '🍬', '🍭', '🍮', '🍯',
  '🍼', '🥛', '☕', '🫖', '🍵', '🍶', '🍾', '🍷',
  '🍸', '🍹', '🍺', '🍻', '🥂', '🥃', '🥤', '🧋',
  '🧃', '🧉', '🧊', '🥢', '🍽️', '🍴', '🥄', '🔪',
  // Предметы, техника, офис
  '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️',
  '🖲️', '🕹️', '🗜️', '💽', '💾', '💿', '📀', '📼',
  '📷', '📸', '📹', '🎥', '📽️', '🎞️', '📞', '☎️',
  '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭',
  '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋',
  '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸',
  '💵', '💴', '💶', '💷', '🪙', '💰', '💳', '💎',
  '⚖️', '🪜', '🧰', '🪛', '🔧', '🔨', '⚒️', '🛠️',
  '⛏️', '🪚', '🔩', '⚙️', '🪤', '🧱', '⛓️', '🧲',
  '🔫', '💣', '🧨', '🪓', '🔪', '🗡️', '⚔️', '🛡️',
  '🚬', '⚰️', '🪦', '⚱️', '🏺', '🔮', '📿', '🧿',
  '💈', '⚗️', '🔭', '🔬', '🕳️', '🩹', '🩺', '💊',
  '💉', '🩸', '🧬', '🦠', '🧫', '🧪', '🌡️', '🧹',
  '🪠', '🧺', '🧻', '🚽', '🚰', '🚿', '🛁', '🛀',
  '🧼', '🪥', '🪒', '🧽', '🪣', '🧴', '🛎️', '🔑',
  '🗝️', '🚪', '🪑', '🛋️', '🛏️', '🛌', '🧸', '🪆',
  '🖼️', '🪞', '🪟', '🛍️', '🛒', '🎁', '🎈', '🎏',
  '🎀', '🪄', '🪅', '🎊', '🎉', '🎎', '🏮', '🎐',
  '🧧', '✉️', '📩', '📨', '📧', '💌', '📥', '📤',
  '📦', '🏷️', '🪧', '📪', '📫', '📬', '📭', '📮',
  '📯', '📜', '📃', '📄', '📑', '🧾', '📊', '📈',
  '📉', '🗒️', '🗓️', '📆', '📅', '🗑️', '📇', '🗃️',
  '🗳️', '🗄️', '📋', '📁', '📂', '🗂️', '📓', '📔',
  '📒', '📕', '📗', '📘', '📙', '📚', '📖', '🔖',
  '🧷', '🔗', '📎', '🖇️', '📐', '📏', '🧮', '📌',
  '📍', '✂️', '🖊️', '🖋️', '✒️', '🖌️', '🖍️', '📝',
  '✏️', '🔍', '🔎', '🔏', '🔐', '🔒', '🔓',
  // Коммуникация и медиа
  '💬', '💭', '🗯️', '💤', '👁️‍🗨️', '🗨️', '🗣️', '👤',
  '👥', '🫂', '👣', '📢', '📣', '🔔', '🔕', '🎵',
  '🎶', '🎼', '🎤', '🎧', '📻', '🎷', '🎸', '🎹',
  '🎺', '🎻', '🪕', '🥁', '🪘', '📯', '🎬', '🎭',
  '🎨', '🎪', '🤹', '🎠', '🎡', '🎢', '🎰', '🎲',
  '🧩', '♟️', '🎯', '🎳', '🎮', '🕹️', '🎰', '🧸',
  // Животные
  '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼',
  '🐻‍❄️', '🐨', '🐯', '🦁', '🐮', '🐷', '🐽', '🐸',
  '🐵', '🙈', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦',
  '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺',
  '🐗', '🐴', '🦄', '🐝', '🪱', '🐛', '🦋', '🐌',
  '🐞', '🐜', '🪰', '🪲', '🪳', '🦟', '🦗', '🕷️',
  '🕸️', '🦂', '🐢', '🐍', '🦎', '🦖', '🦕', '🐙',
  '🦑', '🦐', '🦞', '🦀', '🐡', '🐠', '🐟', '🐬',
  '🐳', '🐋', '🦈', '🐊', '🐅', '🐆', '🦓', '🦍',
  '🦧', '🦣', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒',
  '🦘', '🦬', '🐃', '🐂', '🐄', '🐎', '🐖', '🐏',
  '🐑', '🦙', '🐐', '🦌', '🐕', '🐩', '🦮', '🐕‍🦺',
  '🐈', '🐈‍⬛', '🪶', '🐓', '🦃', '🦤', '🦚', '🦜',
  '🦢', '🦩', '🕊️', '🐇', '🦝', '🦨', '🦡', '🦫',
  '🦦', '🦥', '🐁', '🐀', '🐿️', '🦔',
  // Флаги и прочее
  '🏁', '🚩', '🎌', '🏴', '🏳️', '🏳️‍🌈', '🏳️‍⚧️', '🏴‍☠️',
  '🇷🇺', '🇺🇦', '🇧🇾', '🇰🇿', '🇺🇸', '🇬🇧', '🇩🇪', '🇫🇷',
  '🇮🇹', '🇪🇸', '🇨🇳', '🇯🇵', '🇰🇷', '🇮🇳', '🇹🇷', '🇵🇱',
])];

const TELEGRAM_TYPE_LABELS = {
  renew_3d: 'Напоминание за 3 дня до окончания',
  renew_1d: 'Напоминание за 1 день до окончания',
  service_stopped: 'Прокси отключены (просрочка)',
  proxy_unavailable: 'Прокси недоступен — свои (интервал из правила чекера)',
  proxy_unavailable_foreign: 'Прокси недоступен — чужие (сторонний поставщик)',
  proxy_restored: 'Прокси снова доступен — свои',
  proxy_restored_foreign: 'Прокси снова доступен — чужие',
  regional_restrictions: 'Ограничения в регионе (модемы)',
  payment_accepted: 'Оплата принята',
  payment_failed_client: 'Ошибка оплаты (клиенту)',
  admin_order_alert: 'Админам: заказ / возврат',
  admin_commerce: 'Админам: покупки, продления, пополнение баланса ЛК',
  admin_new_registration: 'Админам: новая регистрация пользователя ЛК',
  admin_modem_reserve_alert: 'Админам: исчерпан резерв модемов на сервере',
  admin_sim_payment_overdue: 'Админам: просрочена оплата SIM (Sim Manager)',
  admin_periodic_report: 'Админам: ежедневный / еженедельный / ежемесячный отчёт',
  balance_auto_renewal_client: 'Клиенту: автопродление прокси с баланса ЛК',
};

const TELEGRAM_ADMIN_TYPE_KEYS = new Set([
  'admin_order_alert',
  'admin_commerce',
  'admin_new_registration',
  'admin_modem_reserve_alert',
  'admin_sim_payment_overdue',
  'admin_periodic_report',
]);

const DEFAULT_ADMIN_COMMERCE_TEMPLATES = {
  template_purchase:
    'Клиент {client_login} купил {proxy_kind_phrase} {qty} шт на сумму {amount_rub} руб',
  template_renewal:
    'Клиент {client_login} продлил {proxy_kind_phrase} {qty} шт на сумму {amount_rub} руб',
  template_balance_topup:
    'Клиент {client_login} пополнил баланс Личного кабинета на сумму {amount_rub} руб',
};
const DEFAULT_REGIONAL_RESTRICTIONS_TEMPLATES = {
  template:
    '❗ В регионе «{region}» введены ограничения на мобильный интернет, прокси могут работать с перебоями.',
  template_restored:
    '✅ В регионе «{region}» сняты ограничения мобильного интернета, работа прокси восстановлена',
};
const DEFAULT_ADMIN_MODEM_RESERVE_ALERT_TEMPLATE =
  '⚠️ В городе «{city}» на сервере «{connection_name}» не работает {unavailable_count} шт. Свободных модемов: {free_modems}.';
const DEFAULT_ADMIN_MODEM_RESERVE_ALERT_RESTORED_TEMPLATE =
  '✅ В городе «{city}» на сервере «{connection_name}» резерв модемов восстановлен. Свободных: {free_modems}, недоступных: {unavailable_count}.';
const DEFAULT_ADMIN_SIM_PAYMENT_OVERDUE_TEMPLATE =
  'Срочно произведите оплату SIM карт сервер «{connection_name}» модем(ы) {modem_numbers}';
const MAX_TELEGRAM_BOT_PROXIES = 20;

const normalizeTelegramBotProxies = (raw) => {
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const item of raw) {
    const text = String(item ?? '').trim();
    if (!text) continue;
    const key = text.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(text);
    if (out.length >= MAX_TELEGRAM_BOT_PROXIES) break;
  }
  return out;
};
const normalizeTelegramFromApi = (raw) => {
  const r = raw && typeof raw === 'object' ? raw : {};
  const base = {
    enabled: !!r.enabled,
    timezone: r.timezone || 'Europe/Moscow',
    daily_send_time: r.daily_send_time || '10:00',
    bot_username: r.bot_username || '',
    lk_public_url: r.lk_public_url || 'https://lk.lte-center.ru',
    manager_clients_url_base: r.manager_clients_url_base || 'https://manager.lte-center.ru/clients',
    types: {},
    broadcasts: Array.isArray(r.broadcasts) ? r.broadcasts.map((b) => ({ ...b })) : [],
    admin_telegram_chat_ids: Array.isArray(r.admin_telegram_chat_ids)
      ? r.admin_telegram_chat_ids.map((x) => parseInt(x, 10)).filter((n) => Number.isFinite(n))
      : [],
  };
  const prevTypes = r.types && typeof r.types === 'object' ? r.types : {};
  Object.keys(TELEGRAM_TYPE_LABELS).forEach((k) => {
    const pt = prevTypes[k] && typeof prevTypes[k] === 'object' ? prevTypes[k] : {};
    if (k === 'admin_commerce') {
      const pick = (field) => {
        const v = pt[field];
        return typeof v === 'string' && v.trim() ? v : DEFAULT_ADMIN_COMMERCE_TEMPLATES[field];
      };
      base.types[k] = {
        enabled: pt.enabled !== false,
        notify_manager: pt.notify_manager === true,
        template_purchase: pick('template_purchase'),
        template_renewal: pick('template_renewal'),
        template_balance_topup: pick('template_balance_topup'),
      };
      return;
    }
    if (k === 'regional_restrictions') {
      const pickRegional = (field) => {
        const v = pt[field];
        return typeof v === 'string' && v.trim() ? v : DEFAULT_REGIONAL_RESTRICTIONS_TEMPLATES[field];
      };
      base.types[k] = {
        enabled: pt.enabled !== false,
        template: pickRegional('template'),
        template_restored: pickRegional('template_restored'),
      };
      return;
    }
    if (k === 'admin_modem_reserve_alert') {
      const tpl = pt.template;
      const tplRestored = pt.template_restored;
      base.types[k] = {
        enabled: pt.enabled !== false,
        notify_manager: pt.notify_manager === true,
        template:
          typeof tpl === 'string' && tpl.trim()
            ? tpl
            : DEFAULT_ADMIN_MODEM_RESERVE_ALERT_TEMPLATE,
        template_restored:
          typeof tplRestored === 'string' && tplRestored.trim()
            ? tplRestored
            : DEFAULT_ADMIN_MODEM_RESERVE_ALERT_RESTORED_TEMPLATE,
      };
      return;
    }
    if (k === 'admin_sim_payment_overdue') {
      const tpl = pt.template;
      const sendTime = pt.send_time_hhmm;
      base.types[k] = {
        enabled: pt.enabled !== false,
        notify_manager: pt.notify_manager === true,
        template:
          typeof tpl === 'string' && tpl.trim()
            ? tpl
            : DEFAULT_ADMIN_SIM_PAYMENT_OVERDUE_TEMPLATE,
        send_time_hhmm:
          typeof sendTime === 'string' && sendTime.trim() ? sendTime.trim().slice(0, 5) : '09:00',
      };
      return;
    }
    if (k === 'admin_periodic_report') {
      const sendTime = pt.send_time_hhmm;
      base.types[k] = {
        enabled: pt.enabled !== false,
        notify_manager: pt.notify_manager === true,
        send_time_hhmm:
          typeof sendTime === 'string' && sendTime.trim() ? sendTime.trim().slice(0, 5) : '00:10',
      };
      return;
    }
    base.types[k] = {
      enabled: pt.enabled !== false,
      template: typeof pt.template === 'string' ? pt.template : '',
    };
    if (TELEGRAM_ADMIN_TYPE_KEYS.has(k)) {
      base.types[k].notify_manager = pt.notify_manager === true;
    }
  });
  return base;
};

const normalizeInformerTargetClientIds = (raw) => {
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const x of raw) {
    const n = parseInt(x, 10);
    if (!Number.isFinite(n) || n < 1 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
    if (out.length >= 200) break;
  }
  return out.sort((a, b) => a - b);
};

/** Фильтр опций Select аудитории информера (логин, email из подписи, id). */
const informerClientSelectFilterOption = (input, option) => {
  const q = String(input ?? '').trim().toLowerCase();
  if (!q) return true;
  const label = String(option?.label ?? '').toLowerCase();
  const val = String(option?.value ?? '');
  return label.includes(q) || val === q || val.includes(q);
};

const normalizeInformerTemplateRow = (item) => ({
  id: item.id,
  name: item.name || '',
  text: item.text || '',
  enabled: item.enabled !== false,
  dismissible: item.dismissible !== false,
  starts_at: item.starts_at || null,
  ends_at: item.ends_at || null,
  targetClientIds: normalizeInformerTargetClientIds(item.target_client_ids),
});

const informerTemplateWithinWindow = (tpl) => {
  if (!tpl.starts_at && !tpl.ends_at) return true;
  const now = dayjs();
  if (tpl.starts_at && dayjs(tpl.starts_at).isAfter(now)) return false;
  if (tpl.ends_at && dayjs(tpl.ends_at).isBefore(now)) return false;
  return true;
};

const normalizeInformerPublications = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw.map((item) => ({
    seq: Number(item.seq || 0),
    text: item.text || '',
    source_template_id: typeof item.source_template_id === 'string' ? item.source_template_id : '',
    target_client_ids: normalizeInformerTargetClientIds(item.target_client_ids),
    published_at: item.published_at || null,
  }));
};

const pickCabinetDefaultsSavedRoot = (response, fallback = null) => {
  const saved = response?.data?.data ?? response?.data ?? null;
  if (saved && typeof saved === 'object' && saved.informer && typeof saved.informer === 'object') {
    return saved;
  }
  if (fallback && typeof fallback === 'object') {
    return fallback;
  }
  return null;
};

/** active — шаблон включён и показывается всем; inactive — выключен или вне периода */
const getTemplateLiveStatus = (tpl, _publications, globalEnabled) => {
  if (!tpl?.id) return 'inactive';
  if (!globalEnabled || tpl.enabled === false || !informerTemplateWithinWindow(tpl)) {
    return 'inactive';
  }
  if (!getInformerEditorPlainText(tpl.text || '')) return 'inactive';
  return 'active';
};

/** Текст без тегов — для проверки «пусто ли поле» при HTML в редакторе */
const getInformerEditorPlainText = (html) => {
  if (html == null || html === '') return '';
  if (typeof html !== 'string') return '';
  try {
    const d = document.createElement('div');
    d.innerHTML = html;
    return (d.textContent || '').replace(/\u00a0/g, ' ').trim();
  } catch (e) {
    return String(html).replace(/<[^>]*>/g, '').trim();
  }
};

export const MARKETING_SECTION_DIRTY_INITIAL = Object.freeze({
  informer: false,
  broadcasts: false,
  notifications: false,
});

export const getClientTelegramTypeKeys = () =>
  Object.keys(TELEGRAM_TYPE_LABELS).filter((k) => !TELEGRAM_ADMIN_TYPE_KEYS.has(k));

export const getAdminTelegramTypeKeys = () =>
  Object.keys(TELEGRAM_TYPE_LABELS).filter((k) => TELEGRAM_ADMIN_TYPE_KEYS.has(k));

export const cloneTelegramForApi = (telegramState) =>
  JSON.parse(JSON.stringify(telegramState || normalizeTelegramFromApi({})));

export const buildInformerApiPayload = (state, informerPatch = {}) => {
  const {
    informerRef,
    templatesRef,
    editorRef,
  } = state;
  const inf = informerRef.current;
  const tplList = templatesRef.current;
  const editorEl = editorRef.current;
  const {
    text: textPatch,
    publish_to_clients: publishToClientsPatch,
    target_client_ids: targetClientIdsFromPatch,
    bump_version: bumpVersionFromPatch,
    publication_text: publicationTextPatch,
    publication_target_client_ids: publicationTargetClientIdsPatch,
    enabled: enabledPatch,
    ...restInformerPatch
  } = informerPatch || {};
  let informerText;
  if (textPatch !== undefined) {
    informerText = textPatch;
  } else if (editorEl && typeof editorEl.innerHTML === 'string') {
    informerText = editorEl.innerHTML;
  } else {
    informerText = inf.text || '';
  }
  return {
    enabled: enabledPatch !== undefined ? !!enabledPatch : !!inf.enabled,
    text: informerText,
    dismissible: inf.dismissible !== false,
    templates: tplList.map((item) => ({
      id: item.id,
      name: item.name || '',
      text: item.text || '',
      enabled: item.enabled !== false,
      dismissible: item.dismissible !== false,
      starts_at: item.starts_at || null,
      ends_at: item.ends_at || null,
      target_client_ids: [],
    })),
    ...(publishToClientsPatch !== undefined ? { publish_to_clients: publishToClientsPatch } : {}),
    ...(bumpVersionFromPatch !== undefined ? { bump_version: bumpVersionFromPatch } : {}),
    ...(publicationTextPatch !== undefined ? { publication_text: publicationTextPatch } : {}),
    ...(publicationTargetClientIdsPatch !== undefined
      ? {
          publication_target_client_ids: normalizeInformerTargetClientIds(
            publicationTargetClientIdsPatch,
          ),
        }
      : {}),
    ...restInformerPatch,
    ...(bumpVersionFromPatch === true ? { publish_to_clients: true } : {}),
    target_client_ids: [],
  };
};

export {
  CABINET_INFORMER_TEMPLATES_MAX,
  INFORMER_EMOJI_OPTIONS,
  TELEGRAM_TYPE_LABELS,
  TELEGRAM_ADMIN_TYPE_KEYS,
  MAX_TELEGRAM_BOT_PROXIES,
  normalizeTelegramBotProxies,
  normalizeTelegramFromApi,
  normalizeInformerTargetClientIds,
  informerClientSelectFilterOption,
  normalizeInformerTemplateRow,
  informerTemplateWithinWindow,
  normalizeInformerPublications,
  pickCabinetDefaultsSavedRoot,
  getTemplateLiveStatus,
  getInformerEditorPlainText,
};
